export default "__VITE_ASSET__390935ca__"